/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Edit from './Edit/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Description"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Edit'}>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}